// The WooCommerce store whose upgrade orders these payouts cover.
const wcStoreUrl =
  process.env.REACT_APP_WOOCOMMERCE_URL || "https://info.enjoyspi.com";

// The order's edit screen in WP admin (the store uses HPOS order tables).
export const wcOrderAdminUrl = (orderId) =>
  `${wcStoreUrl}/wp-admin/admin.php?page=wc-orders&action=edit&id=${orderId}`;
